import { render, staticRenderFns } from "./EditClientDetailsModal.vue?vue&type=template&id=6ceefcef"
import script from "./EditClientDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditClientDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports